




























import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import ExamSelect from '@/components/select/ExamSelect.vue'
import { randKey } from '@/utils/random'


@Component({
  components: { ExamSelect }
})
export default class Upload extends Vue {
  @Prop({ required: true }) upload!: Function 
  @Prop({ required: true }) downLoadUrl!: string

  getKey = randKey



  get handleUpload() {
    const uploader = this.upload
    const wrapper = async (...args: any[]) => {
      const re = await uploader(...args)
      if (re) this.$emit('success')
      return re
    }
    return wrapper
  }
}
